export default __webpack_public_path__ + "c4709b4553f6bb4ccfcb571fb1e45456.svg";